<template>

  <div class="swiper_div d-none d-sm-block">

    <swiper :options="swiperOption" :not-next-tick="notNextTick" ref="mySwiper" class="sw" v-if="currentLanguage==0">
      <!-- slides -->
      <div class="swiper-button-prev" slot="button-prev"><i class="el-icon-arrow-left"></i></div>
      <swiper-slide>
        <div class="box">
          <a href="newsDetail?id=54&source=indexCalendar" target="_blank"> <img src="@/assets/img/bhbia.png" class="nearest"></a>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">
          <a href="newsDetail?id=52&source=indexCalendar" target="_blank"><img src="@/assets/img/intellcander.png"></a>

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">
          <!-- <a href="https://www.intellus.org/" target="_blank"> -->
          <img src="@/assets/img/dinner.png">
          <!-- </a> -->

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">
          <a href="/newsDetail?id=37&source=indexCalendar" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar4.png"></a>

        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="box">
          <a href="/newsDetail?id=36&source=indexCalendar" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar3.png"></a>

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">
          <a href="https://www.sages.org/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar2.png"></a>

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">

          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar1.png">

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">
          <!-- <a href="https://www.acc.org/" target="_blank"> -->
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar10.png">
          <!-- </a> -->

        </div>
      </swiper-slide>
      <swiper-slide>

        <div class="box">
          <a href="https://holdendata.com/newsDetail?id=33&source=companyNews" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar9.png"></a>

        </div>
      </swiper-slide>

      <div class="swiper-button-next" slot="button-next"><i class="el-icon-arrow-right"></i></div>

    </swiper>
    <!-- 中文版 -->
    <swiper :options="swiperOption" :not-next-tick="notNextTick" ref="mySwiper" class="sw" v-if="currentLanguage==1">
      <!-- slides -->
      <div class="swiper-button-prev" slot="button-prev"><i class="el-icon-arrow-left"></i></div>
      <swiper-slide>
        <div class="box">
                <a href="newsDetail?id=54&source=indexCalendar" target="_blank"> <img src="@/assets/img/bhbia.png" class="nearest"></a>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">
          <a href="newsDetail?id=52&source=indexCalendar" target="_blank"><img src="@/assets/img/intellcander.png"></a>

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">
          <!-- <a href="https://www.intellus.org/" target="_blank"> -->
          <img src="@/assets/img/dinner.png">
          <!-- </a> -->

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">
          <a href="/newsDetail?id=37&source=indexCalendar" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar4.png"></a>

        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="box">
          <a href="/newsDetail?id=36&source=indexCalendar" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar3.png"></a>

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">
          <a href="https://www.sages.org/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar2.png"></a>

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">

          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar1.png">

        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="box">
          <!-- <a href="https://www.acc.org/" target="_blank"> -->
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar10.png">
          <!-- </a> -->

        </div>
      </swiper-slide>
      <swiper-slide>

        <div class="box">
          <a href="https://holdendata.com/newsDetail?id=33&source=companyNews" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/calendar/calendar9.png"></a>

        </div>
      </swiper-slide>

      <div class="swiper-button-next" slot="button-next"><i class="el-icon-arrow-right"></i></div>

    </swiper>
  </div>

</template>

<script>
export default {
  name: "carrousel",
  props: {
    videoList: {
      type: Array
    }
  },
  data() {
    return {
      // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
      notNextTick: true,
      swiperOption: {
        // swiper options 所有的配置同swiper官方api配置
        autoplay: false, // 自动播放的时间间隔
        slidesPerView: 4, //一次显示的数量
        direction: "horizontal", // 水平轮播
        grabCursor: true,
        setWrapperSize: true,
        loop: false, //  循环播放
        autoHeight: true,
        // pagination: ".swiper-pagination",
        paginationClickable: true,
        initialSlide: 0,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        // scrollbar: ".swiper-scrollbar",
        mousewheelControl: false,
        observeParents: true,
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        debugger: true,
        // swiper callbacks
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        onTransitionStart(swiper) {
          console.log(swiper);
        }
        // more Swiper configs and callbacks...
        // ...
      }
    };
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    currentLanguage() {
      return Number(this.$store.state.lang);
    }
  },

  mounted() {
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //   console.log('this is current swiper instance object', this.swiper)
    //   this.swiper.slideTo(3, 1000, false)
  }
};
</script>

<style lang="scss" scoped>
.swiper_div {
  // display: flex;
  position: relative;
  background-color: #fff;
  //   overflow: hidden;
}

.swiper-container {
  //   position: static;
  /* border: 1px solid #000; */
  //   border: 1px solid #000;
  height: 400px;
  overflow: hidden;
  margin: 0 auto;
}
.sw {
  width: 100%;
  /* height: 100px; */
  text-align: center;
}
/* .sw video {
  height: 2rem;
  width: 3.2rem;
} */

.swiper-button-next {
  /* background-image: url('../../static/images/left.png');
     */
  color: rgb(27, 26, 26);
  height: 40px;
  width: 40px;
  border-radius: 50%;
  position: absolute;
  top: 150px !important;
  right: -55px;
  margin-top: 0;
  background: rgba(194, 191, 191, 0.5);
  display: inline-block;
  padding-top: 8px;
}
.swiper-wrapper {
  width: 100%;
}
.swiper-slide {
  .box {
    // border: 1px solid #f6f6f6;
    // padding: 10px;
    // height: 300px;
    margin: 10px 20px;
    border-radius: 8px;
    color: #409eff;
    // background-color: #ecf5ff;
    img {
      width: 100%;
      border: 1px solid #c5c0c0;
    }
    .nearest {
      box-shadow: 0px 0px 15px #797a7a;
    }
    .small {
      font-size: 10px;
    }
    .data {
      //   font-weight: 700;
    }
  }
  width: 20%;
  //    border: 1px solid #000;
}
.test {
  border: 1px solid #409eff;
  padding: 10px;
  height: 100px;
  margin: 10px;
  border-radius: 8px;
  color: #fff;
  background-color: #409eff;
  // width: 50%;
}
.swiper-button-prev {
  display: inline-block;
  position: absolute;
  padding-top: 8px;

  color: rgb(27, 26, 26);
  height: 40px;
  width: 40px;
  border-radius: 50%;
  top: 150px !important;
  left: -50px;
  margin-top: 0;
  background: rgba(194, 191, 191, 0.5);
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 20px;
}
</style>